import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { HrComment, CreateHrCommentDTO } from '@/types';

export function useComments(candidateId: string | null) {
  return useQuery({
    queryKey: ['comments', candidateId],
    queryFn: () => api.get<HrComment[]>(`/api/candidates/${candidateId}/comments`),
    enabled: !!candidateId,
  });
}

export function useCreateComment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateHrCommentDTO) =>
      api.post<HrComment>(`/api/candidates/${dto.candidate_id}/comments`, { text: dto.text }),
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ['comments', variables.candidate_id] });
      qc.invalidateQueries({ queryKey: ['candidates', variables.candidate_id] });
    },
  });
}

export function useDeleteComment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ candidateId, commentId }: { candidateId: string; commentId: string }) =>
      api.delete(`/api/candidates/${candidateId}/comments/${commentId}`),
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ['comments', variables.candidateId] });
    },
  });
}
